import React, { Component } from 'react';

export default class PhotoIcon extends Component {
    render() {
        return (
            <svg version="1.1" width="15px" viewBox="0 0 182 182">
                <g fill="#333333">
                    <path d="M152.3,0H29.7C13.3,0,0,13.3,0,29.7v122.7C0,168.7,13.3,182,29.7,182h122.7c16.4,0,29.7-13.3,29.7-29.7V29.7C182,13.3,168.7,0,152.3,0z M29.7,11h122.7c10.3,0,18.7,8.4,18.7,18.7v101.7c-0.4,0-0.8,0-1.2,0c-3.7,0-7.8,0-10.7,0l-12.1-23.8c-0.9-1.7-2.6-2.9-4.5-3c-1.9-0.1-3.8,0.8-4.9,2.4l-6.2,9l-16.6-26.8c-0.9-1.5-2.6-2.5-4.3-2.6c-1.8-0.1-3.5,0.6-4.6,2l-34.8,43H11V29.7C11,19.4,19.4,11,29.7,11z M152.3,171H29.7c-10.3,0-18.7-8.4-18.7-18.7v-9.8h62.5c1.7,0,3.2-0.7,4.3-2l31.6-39.1l16.9,27.4c1,1.6,2.7,2.6,4.5,2.6c1.8,0,3.6-0.9,4.7-2.4l5.8-8.4l9.5,18.6c1,1.9,2.9,3.1,5.1,3c2.1-0.1,8.9,0,13.9,0c0.4,0,0.9,0,1.3,0v10C171,162.6,162.6,171,152.3,171z" />
                    <path d="M61.5,89C76.1,89,88,77.1,88,62.5S76.1,36,61.5,36S35,47.9,35,62.5S46.9,89,61.5,89z M61.5,47C70,47,77,54,77,62.5S70,78,61.5,78S46,71,46,62.5S53,47,61.5,47z" />
                </g>
            </svg>
        );
    }
}
